export default __webpack_public_path__ + "static/media/user_poap_02.b409458c.svg";